const initialState = {
    openId: {
        nonce: null,
        codeVerifier: null,
        state: null,
        authorizationCode: null,
    },
    authorizationToken: null,
    authorizeUrl: null,
    isLoggedIn: false,
    isFakeLoggedIn: false,
    isLoadingRegister: false,
    isLoadingDependants: false,
    isLoadingLogin: false,
    isLoadingDependantList: false,
}

export default function api(state = initialState, action) {
    switch(action.type) {
        case "SET_OPENID_VARIABLES":
            return {
                ...state,
                openId: {
                    codeVerifier: action.codeVerifier,
                    nonce: action.nonce,
                    state: action.state,
                    authorizationCode: action.authorizationCode,
                },
                authorizeUrl: action.authorizeUrl,
            }
        case "SET_OPENID_AUTHORIZATION_CODE":
            return {
                ...state,
                openId: {
                    ...state.openId,
                    authorizationCode: action.data,
                }
            }
        case "SET_OPENID_AUTHORIZE_URL":
            return {
                ...state,
                authorizeUrl: action.data,
            }
        case "SET_AUTHORIZATION_TOKEN":
            return {
                ...state,
                authorizationToken: action.data,
            }
        case "SET_LOGIN_STATE":
            return {
                ...state,
                isLoggedIn: action.data,
            }
        case "SET_LOGGING_IN":
            return {
                ...state,
                isLoadingLogin: action.data,
            }
        case "SET_REGISTERING":
            return {
                ...state,
                isLoadingRegister: action.data,
            }
        case "SET_GET_DEPENDANT":
            return {
                ...state,
                isLoadingDependantList: action.data,
            }
        case "GET_DEPENDANTS":
            return {
                ...state,
                isLoadingDependants: action.data,
            }
        case "SET_FAKE_LOGIN_STATE":
            return {
                ...state,
                isFakeLoggedIn: action.data,
            }
        case "IS_ADDING_ACCESS":
            return {
                ...state,
                isAddingAccess: action.data,
            }
        case "SET_IS_LOGGING_OUT":
            return{
                ...state,
                isLoggingOut: action.data,
            }
        case "CLEAR_AUTH_DATA":
            return {
                ...state,
                openId: {
                    nonce: null,
                    codeVerifier: null,
                    state: null,
                    authorizationCode: null,
                },
                authorizationToken: null,
                authorizeUrl: null,
                isLoggedIn: false,
                isFakeLoggedIn: false,
                isLoadingLogin: false,
            }
        default:
            return state;
    }
}
